// Adapta el snapshot del public-api al objeto anidado "legacy" que este bulletin
// consume. Tras el refactor a $facet, el public-api entrega el snapshot como un
// ARRAY plano ([{_id:{state,name,district_id,ballotbox_id}, count, weighted, factor}]);
// los bulletins viejos leen snapshot.districts (objeto) directo y crashean con
// "Object.keys(undefined)". Este adaptador reconstruye el shape en el cliente,
// igual que hace el bulletin moderno (main) vía adapterSnapshotData/ensureLegacyFormat.

const createEmptyStats = () => ({
    electronic_voted: 0,
    manual_voted: 0,
    ready: 0,
    ready_defaulting: 0,
    ready_disabled: 0,
    registered: 0,
    registered_defaulting: 0,
    registered_disabled: 0,
});

export const adapterSnapshotData = (newData, electionId) => {
    const root = {
        _id: electionId,
        name: electionId,
        total_voters: 0,
        total_weighted: 0,
        voters: createEmptyStats(),
        weighted: createEmptyStats(),
        districts: {},
    };

    newData.forEach((item) => {
        const {state, name, district_id, ballotbox_id} = item._id;
        const count = item.count;
        const weighted = item.weighted;

        // 1. Totales globales
        root.voters[state] += count;
        root.weighted[state] += weighted;
        root.total_voters += count;
        root.total_weighted += weighted;

        // 2. Distrito (district_id se agrega por sobre el adapter de main: los
        //    componentes viejos lo usan como key, ej. TurnoutTable/BallotBoxRow)
        if (!root.districts[district_id]) {
            root.districts[district_id] = {
                district_id: district_id,
                name: name,
                factor: item.factor,
                voters: createEmptyStats(),
                weighted: createEmptyStats(),
                ballotboxes: {},
            };
        }

        const d = root.districts[district_id];
        d.voters[state] += count;
        d.weighted[state] += weighted;

        // 3. Ballotbox (el array no trae nombre de mesa; se usa el mismo default que main)
        if (!d.ballotboxes[ballotbox_id]) {
            d.ballotboxes[ballotbox_id] = {
                name: 'mesa única',
                voters: createEmptyStats(),
                weighted: createEmptyStats(),
            };
        }

        const b = d.ballotboxes[ballotbox_id];
        b.voters[state] += count;
        b.weighted[state] += weighted;
    });

    return root;
};

// Deja pasar intacto el objeto del backup; solo transforma el array del API.
export const ensureLegacyFormat = (data, electionId) =>
    Array.isArray(data) ? adapterSnapshotData(data, electionId) : data;
